import {useContext, useState} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import Context from '@s-ui/react-context'
import MoleculeInputField from '@s-ui/react-molecule-input-field'

import {useUserProfileEditTracking} from '../../hooks/useUserProfileEditTracking/index.js'
import {useFormUserModifyPasswordConfiguration} from './useFormUserModifyPasswordConfiguration.js'

const BASE_CLASS = 'mt-userProfileEdit-formUserModifyPassword'

const FormUserModifyPassword = ({onClickGoBack = () => {}}) => {
  const {domain, i18n} = useContext(Context)

  const {checkConstraints, fields, isValidForm, modifyPasswordFields} = useFormUserModifyPasswordConfiguration()

  const {trackError, trackSuccess} = useUserProfileEditTracking()

  const [isLoading, setIsLoading] = useState(false)

  const handleOnSubmit = async () => {
    setIsLoading(true)

    const errors = checkConstraints({fields})

    if (!isValidForm(errors)) {
      trackError({formErrors: errors})
    } else {
      const {currentPassword, newPassword} = fields

      const [updatingPasswordError] = await domain
        .get('update_password_user_use_case')
        .execute({password: currentPassword, newPassword})

      if (updatingPasswordError) {
        trackError()
      } else {
        trackSuccess()
        window.location.href = '/logout.aspx'
      }
    }

    setIsLoading(false)
  }

  const handleClickGoBack = () => {
    onClickGoBack()
  }

  return (
    <div className={BASE_CLASS}>
      <h2 className={`${BASE_CLASS}-title`}>{i18n.t('COMMON.NEW_PASSWORD')}</h2>
      <form className={`${BASE_CLASS}-form`}>
        {modifyPasswordFields.map(fieldConfig => (
          <MoleculeInputField {...fieldConfig} />
        ))}
      </form>
      <div className={`${BASE_CLASS}-buttons`}>
        <AtomButton
          shape={atomButtonShapes.CIRCULAR}
          onClick={handleOnSubmit}
          isLoading={isLoading}
          size={atomButtonSizes.LARGE}
        >
          {i18n.t('COMMON.CHANGE_PASSWORD')}
        </AtomButton>
        <AtomButton
          design={atomButtonDesigns.FLAT}
          onClick={handleClickGoBack}
          size={atomButtonSizes.MEDIUM}
          shape={atomButtonShapes.CIRCULAR}
        >
          {i18n.t('COMMON.CANCEL')}
        </AtomButton>
      </div>
    </div>
  )
}

FormUserModifyPassword.displayName = 'FormUserModifyPassword'

FormUserModifyPassword.propTypes = {
  onClickGoBack: PropTypes.func
}

export default FormUserModifyPassword
